import { ThunkType } from "../../../../core/store/reducers";
import { setData } from "../annualTradeDataSlice";
import getAnnualProductData from "../api/getAnnualProductData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.annualTrade;

  const pagedTrades = await dispatch(getAnnualProductData(user, filter));

  dispatch(setData(pagedTrades || []));
};
